// src/pages/SprintCentralThreePF.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@fortawesome/free-solid-svg-icons';

const SprintCentralThreePF = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("3P");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "3P", emoji: "🧮" },
    { label: "Digital Income", emoji: "💰" },
    { label: "Learning & Development", emoji: "📚" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "PTM 3P Help", emoji: "🧗" },
    { label: "3P Contest", emoji: "🏆" }, 
    { label: "3P Games", emoji: "🎮" },
  ];

  const menuButtons1 = [
    // 🧮 3P New
    { label: "3P New", emoji: "🧮", link: "/threep-form", group: "3P" },
    { label: "My 3Ps", emoji: "📊", link: "/threep-mylist", group: "3P" },
    { label: "3P Calculator", emoji: "🔢", link: "/threep-calculator", group: "3P" },

    // 💰 DIGITAL INCOME
    { label: "Monthly Digital Income", emoji: "💻🌱", link: "/threep-bookworld", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Resell", emoji: "♻️", link: "/threep-enroll", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Income" },

    // 📚 Learning & Development
    { label: "3P Learning", emoji: "🗓️", link: "/threep-bookworld", group: "Learning & Development" },
    { label: "Bookshelf", emoji: "📖", link: "/bookshelf", group: "Learning & Development" },
    { label: "3P Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Learning & Development" },

    // 🪞 SELF REFLECTION
    { label: "Personal Digital Card", emoji: "📘", link: "/threep-digitalcard", group: "Self Reflection" },
    { label: "Self Management", emoji: "🙋‍♀️", link: "/threep-self-chronicles", group: "Self Reflection" },
    { label: "Diary", emoji: "📔", link: "/mydiary-home", group: "Self Reflection" },
    { label: "Journal", emoji: "🗒️", link: "/myjournal-home", group: "Self Reflection" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Self Reflection" },
    // { label: "Focus Timer", emoji: "⏱️", link: "/threep-focustimerstart", group: "Self Reflection" },
    // { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Self Reflection" },
    // { label: "My Outreach", emoji: "📣👥", link: "/outreach", group: "Self Reflection" },
    // { label: "My Limit", emoji: "️📏", link: "/mylimit", group: "Self Reflection" },

    // 🎮 3P Games
    { label: "3P Tambola", emoji: "🎟️", link: "/threep-games-tambola", group: "3P Games" },
    { label: "3P Bingo", emoji: "🔢", link: "/threep-games-bingo", group: "3P Games" },    

    // 🧗 PTM 3P Help
    { label: "About", emoji: "🧠", link: "/threep-about", group: "PTM 3P Help" },
    { label: "Use-Cases", emoji: "🧩", link: "/threep-usage", group: "PTM 3P Help" },
    { label: "How to Use", emoji: "❓", link: "/threep-help", group: "PTM 3P Help" },
    { label: "3P for Students", emoji: "👨‍🎓", link: "/threep-students", group: "PTM 3P Help" },
    { label: "3P for Teachers", emoji: "🧑‍🏫", link: "/threep-teachers", group: "PTM 3P Help" },
    { label: "3P for MSME / Owners", emoji: "💼", link: "/threep-msme", group: "PTM 3P Help" },
    { label: "3P for Workers", emoji: "🧑‍🏭", link: "/threep-workers", group: "PTM 3P Help" },

    // 🏆 3P Contest
    { label: "3P Contest", emoji: "🏆", link: "/threep-contest", group: "3P Contest" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200"> 
            <FontAwesomeIcon icon={faSliders} className="mr-2 text-yellow-500" />Think5Whys PTM 3P
          </div>
          <div className="text-[11px] text-gray-200">Practical Thinking Mathematics Three Point Estimation.</div>
          <div className="text-xs text-yellow-200">A Magical tool for Students, Teachers, Professionals, MSME Onwers, Workers, Children, Families, Governments, Businesses!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SprintCentralThreePF;
